import { render, staticRenderFns } from "./StaffsGrid.vue?vue&type=template&id=25f312e4&"
import script from "./StaffsGrid.vue?vue&type=script&lang=js&"
export * from "./StaffsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports